import { GetLinks } from "../../../config";

export default [
  {
    key: "/sales-360",
    icon: <i className="ki-outline ki-chart-line fs-1 " />,
    label: GetLinks("/sales-360", "Sales 360"),
  },
];
